import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSite } from "../context/AppContext";

export default function PrivacyPage() {
  const { site } = useSite();
  useEffect(() => {
    document.title = "Privacy Notice | LD Travel";
  }, []);

  return (
    <main className="section-pad" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h1 className="font-heading text-4xl sm:text-5xl text-[#0B1D3A] font-semibold">Privacy Notice</h1>
        <div className="gold-divider mt-5 mb-8" />
        <div className="card-luxe p-7 sm:p-9">
          {(site?.settings?.privacyNotice || "").split("\n").filter(Boolean).map((p, i) => (
            <p key={i} className="text-slate-600 leading-relaxed mb-4" data-testid={`privacy-paragraph-${i}`}>{p}</p>
          ))}
        </div>
        <Link to="/" className="btn-outline !text-[#0B1D3A] mt-8 inline-flex" data-testid="privacy-back-home">Back to Home</Link>
      </div>
    </main>
  );
}
